<template>
  <filter-bar>
    <div class="md-layout md-gutter">
      <div class="md-layout-item md-layout md-medium-size-25 md-small-size-25 md-xsmall-size-100">
        <div class="md-layout-item md-layout md-size-100">
          <md-field>
            <label for="customerS">Tipo de proveedor</label>
            <md-select v-model="providerType" name="type" id="type">
              <md-option :value="0">Sin Filtro</md-option>
              <md-option :value="pt.id" v-for="pt in mProviderType" :key="pt.id">{{ pt.name }}</md-option>
            </md-select>
          </md-field>
        </div>
      </div>

      <div class="md-layout-item md-layout md-medium-size-25 md-small-size-25 md-xsmall-size-100">
        <div class="md-layout-item md-layout md-size-100">
          <md-field>
            <label for="giro">Giro empresarial</label>
            <md-select v-model="coreBusiness" name="giro" id="giro">
              <md-option :value="0">Sin Filtro</md-option>
              <md-option :value="d.id" v-for="d in mCoreBusiness" :key="d.id">{{ d.name }}</md-option>
            </md-select>
          </md-field>
        </div>
      </div>

      <div class="md-layout-item md-layout md-medium-size-25 md-small-size-25 md-xsmall-size-100">
        <div class="md-layout-item md-layout md-size-100">
          <md-field>
            <label for="giro">Estatus</label>
            <md-select v-model="status" name="giro" id="giro">
              <md-option :value="0">Sin Filtro</md-option>
              <md-option
                :value="s.status.id"
                v-for="s in mStatus"
                :key="s.status.id"
              >{{ s.status.name }}</md-option>
            </md-select>
          </md-field>
        </div>
      </div>
    </div>
  </filter-bar>
</template>

<script>
import dataService from "@/services/catalog";
import FilterBar from "@/components/FilterBar";

export default {
  components: {
    FilterBar,
  },
  data() {
    return {
      responsive: false,
      // selected
      providerType: 0,
      coreBusiness: 0,
      status: 0,
      // metadatas
      mProviderType: [],
      mCoreBusiness: [],
      mStatus: [],

      filterFunctions: [],
    };
  },
  props: {
    datasIn: Array,
  },
  methods: {
    registerFilter(filterFunction) {
      this.filterFunctions.push(filterFunction);
    },

    filterF(item) {
      for (let i in this.filterFunctions) {
        if (!this.filterFunctions[i](item)) {
          return false;
        }
      }
      return true;
    },

    consultMetas(ruta, asign, arg) {
      // Make query for metaDatas
      dataService.fetch(ruta, { id: arg, noStore: true }).then((res) => {
        this[asign] = res.sort((a, b) => {
          if (a.status) {
            return a.status.name < b.status.name ? -1 : 1;
          }
          return a.name < b.name ? -1 : 1;
        });
      });
    },

    onResponsiveInverted() {
      if (window.innerWidth < 768) {
        this.responsive = true;
      } else {
        this.responsive = false;
      }
    },
  },
  mounted() {
    this.registerFilter((provider) => {
      // Filter by provider type
      if (!this.providerType) return true;
      let el = provider.provider_type.filter(
        (type) => type.id === this.providerType
      );
      return el.length ? true : false;
    });
    this.registerFilter((provider) => {
      // Filter by core business
      if (!this.coreBusiness) return true;
      let el = provider.core_business.filter((cb) => {
        return cb.id === this.coreBusiness;
      });
      return el.length ? true : false;
    });
    // Filter by provider status
    this.registerFilter((provider) =>
      !this.status ? true : provider.status.id === this.status
    );

    // get metadatas
    this.consultMetas("provider_type", "mProviderType");
    this.consultMetas("core_business", "mCoreBusiness");
    this.consultMetas("common/status/provider", "mStatus");

    this.onResponsiveInverted();
    window.addEventListener("resize", this.onResponsiveInverted);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResponsiveInverted);
  },
  watch: {
    datasOut() {
      this.$emit("filtered", this.datasOut);
    },
  },
  computed: {
    datasOut() {
      return this.datasIn.filter(this.filterF);
    },
  },
};
</script>

<style lang="css" scoped>
.md-card-content:last-of-type {
  padding-bottom: 0;
}

.md-card .md-card-content {
  padding: 0px 15px;
  line-height: 1.75em;
  position: relative;
}

.md-field.md-focused label,
.md-field.md-field.md-has-value label {
  top: -1rem;
}
</style>



// WEBPACK FOOTER //
// src/pages/Providers/filters.vue